import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { spacingHelper } from '@property.com.au/ui-kit';
import stampBushfire from '../../../../assets/stamps/stamp-bushfire.svg';
import stampFlood from '../../../../assets/stamps/stamp-flood.svg';
import stampHeritage from '../../../../assets/stamps/stamp-heritage.svg';

export type StampType = 'Bushfire' | 'Flood' | 'Heritage';

interface StampProps {
  stamp: StampType;
  className?: string;
}

const mapStamp = (stamp: StampType): string => {
  switch (stamp) {
    case 'Bushfire':
      return stampBushfire;
    case 'Flood':
      return stampFlood;
    case 'Heritage':
      return stampHeritage;
  }
};

const StyledImage = styled.img`
  max-height: ${spacingHelper('twoExtraLarge')};
`;

export const Stamp: FunctionComponent<StampProps> = ({ stamp, className }) => {
  return <StyledImage src={mapStamp(stamp)} alt={`${stamp} icon`} className={className} />;
};
